const mutations = {
    add(state, object) {
        state.itens.push(object);
    },
    setList(state, list) {
        state.itens = list;
    },
    setObject(state, object) {
        state.item = object;
    },
    delObject(state, object) {
        state.itens.splice(state.itens.indexOf(object), 1);
    }
};

export default mutations;